import React from "react";

import Button from "../elements/Button";

import yourImage from "../assets/images/Services/Design.png";
import "../assets/css/ServiceStyle.css";

export default function BrandIcon() {
  return (
    <Button className="" type="link" href="/LandingPage2">
      <p className="text-theme-blue text-4xl font-medium ">
        <span className="text-theme-purple">
          <img src={yourImage} alt="Description" className="service-images" />
        </span>
      </p>
    </Button>
  );
}
